import { useQuery } from '@tanstack/react-query';
import locationService, { Country } from '../services/locationService';

const extractFirstCountry = (response: any): Country | null => {
  const payload = response?.data;

  if (Array.isArray(payload)) {
    return payload[0] || null;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data[0] || null;
  }

  return null;
};

export const useInternalShipmentCountries = () => {
  const senderCountryQuery = useQuery({
    queryKey: ['internal-shipment-country', 'IL'],
    queryFn: () => locationService.getCountries({ code: 'IL', per_page: 1 }),
    staleTime: 1000 * 60 * 60,
  });

  const recipientCountryQuery = useQuery({
    queryKey: ['internal-shipment-country', 'US'],
    queryFn: () => locationService.getCountries({ code: 'US', per_page: 1 }),
    staleTime: 1000 * 60 * 60,
  });

  return {
    senderCountry: extractFirstCountry(senderCountryQuery.data),
    recipientCountry: extractFirstCountry(recipientCountryQuery.data),
    isLoading: senderCountryQuery.isLoading || recipientCountryQuery.isLoading,
    error: senderCountryQuery.error || recipientCountryQuery.error,
    senderCountryQuery,
    recipientCountryQuery,
  };
};

export default useInternalShipmentCountries;
